import * as React from 'react'
import Select, { OptionProps, components, GroupBase } from 'react-select'
import { FieldInputProps, FormikHelpers, FormikValues } from 'formik'

import './selectInput.sass'
import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

interface Props {
    label?: string
    options: FormikValues[]
    field: FieldInputProps<string>
    form: FormikHelpers<FormikValues>
    onChangeCallback?: (selectedValue: string, form: FormikHelpers<FormikValues>) => void
    validMessage?: string
    outerRef?: React.MutableRefObject<string | null>
}

const SelectInput: React.FunctionComponent<Props> = ({
    label,
    field,
    options,
    form,
    onChangeCallback,
    validMessage,
    outerRef
}: Props) => {
    const [t] = useTranslation()
    const [isSelectTouched, setIsSelectTouched] = useState(false)

    useEffect(() => {
        // @ts-ignore
        if (form.isSubmitting) setIsSelectTouched(true)
        // @ts-ignore
    }, [form.isSubmitting])

    const Separator = () => <div style={{ borderTop: '1px solid #ccc', margin: '5px 0' }} />

    const Option = (props: JSX.IntrinsicAttributes & OptionProps<unknown, boolean, GroupBase<unknown>>) => {
        // @ts-ignore
        if (props.data.topLine) {
            return <Separator />
        }
        return <components.Option {...props} />
    }

    return (
        <div className="selectInputContainer">
            {label && (
                <label className="label" htmlFor="">
                    {label}
                </label>
            )}
            <Select
                name={field.name}
                options={options}
                components={{ Option }}
                // @ts-ignore
                className={validMessage && field.value == 0 && isSelectTouched ? 'selectInput error' : 'selectInput'}
                classNamePrefix="selectInput"
                isSearchable={false}
                placeholder={options.length > 0 ? t('Select') : t('No options')}
                onChange={(option: OptionProps<FormikValues, false>) => {
                    const value = (option as FormikValues).value
                    form.setFieldValue(field.name, value)
                    if (onChangeCallback) {
                        onChangeCallback(value, form)
                    }
                    if (outerRef) outerRef.current = option.label
                    setIsSelectTouched(true)
                }}
                value={options.find((x) => x.label === field.value || x.value === field.value) || null}
            />
            {/*@ts-ignore*/}
            {validMessage && field.value == 0 && isSelectTouched ? (
                <label className="selectErrorText">
                    {validMessage} {t('should be chosen')}
                </label>
            ) : (
                <></>
            )}
        </div>
    )
}

export default SelectInput
